import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { GLOBAL } from './global';
/*

Remember to replace 'root' with the appropriate module for the service to be provided in. Also,
 ensure that the GLOBAL.url variable points to the correct API endpoint. This updated code should 
 work with Angular 12 or 13 (or similar versions), utilizing modern HttpClient usage and best practices.

*/
@Injectable({
  providedIn: 'root'
})
export class PurchaseTermService {
  public url: string;

  constructor(private _http: HttpClient) {
    this.url = GLOBAL.url;
  }

  getTerms(token: string): Observable<any> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded', 'X-Requested-With': 'XMLHttpRequest' });
    const params = `authorization=${token}`;

    return this._http.post<any>(`${this.url}/purchasingterm/list?page=1`, params, { headers });
  }

  getTermsByCompany(token: string, id: any): Observable<any> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded', 'X-Requested-With': 'XMLHttpRequest' });
    const params = `authorization=${token}`;

    return this._http.post<any>(`${this.url}/purchasingterm/listbycompany/${id}?page=1`, params, { headers });
  }

  getTermsByUser(token: string, id: any): Observable<any> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded', 'X-Requested-With': 'XMLHttpRequest' });
    const params = `authorization=${token}`;

    return this._http.post<any>(`${this.url}/purchasingterm/listbyuser/${id}?page=1`, params, { headers });
  }

  newTerm(token: string, term: any): Observable<any> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded', 'X-Requested-With': 'XMLHttpRequest' });
    const json = encodeURIComponent(JSON.stringify(term));
    const params = `json=${json}&authorization=${token}`;
    const page = 1;

    return this._http.post<any>(`${this.url}/purchasingterm/new?page=${page}`, params, { headers });
  }

  editTerm(token: string, id: any, term: any): Observable<any> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded', 'X-Requested-With': 'XMLHttpRequest' });
    const json = encodeURIComponent(JSON.stringify(term));
    const params = `json=${json}&authorization=${token}`;
    const page = 1;

    return this._http.post<any>(`${this.url}/purchasingterm/edit/${id}?page=${page}`, params, { headers });
  }

  delete(token: string, id: any): Observable<any> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded', 'X-Requested-With': 'XMLHttpRequest' });
    const params = `authorization=${token}`;
    const page = 1;

    return this._http.post<any>(`${this.url}/purchasingterm/remove/${id}?page=${page}`, params, { headers });
  }

  getTerm(token: string, id: any): Observable<any> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded', 'X-Requested-With': 'XMLHttpRequest' });
    const params = `authorization=${token}`;
    const page = 1;

    return this._http.post<any>(`${this.url}/purchasingterm/detail/${id}?page=${page}`, params, { headers });
  }
}
